import React from "react";

import useFTMessageGrowl from "hooks/useFTMessageGrowl";
import VersionImportErrorGrowl from "widgets/messages/VersionImportErrorGrowl";
import VersionExportGrowl from "widgets/messages/VersionExportGrowl";
import VersionImportPreviewGrowl from "widgets/messages/VersionImportPreviewGrowl";

function EXPORT_VERSIONS_NOTIFICATIONS(detail){
	let { task, status, data, downloadLink } = detail?.message || {};
	let { filename, description } = data?.request || {};

	if(/Export versions/i.test(task) && /Success/i.test(status)){
		return {
			type: "success",
			messageHeader: "Success",
			formatter: () => <VersionExportGrowl downloadLink={downloadLink} filename={filename} description={description} />,
		};
	}
}

function IMPORT_SOCIAL_NOTIFICATIONS(detail){
	let { task, status, data } = detail?.message || {};

	if(/Import social creatives/i.test(task) && /Success/i.test(status)){
		let { feedback = "Social creatives successfully imported" } = data?.response || {};

		return {
			type: "success",
			messageHeader: "Success!",
			message: feedback,
		};
	}
}

function IMPORT_VERSIONS_NOTIFICATIONS(detail) {
	let { task, status, data = {} } = detail?.message || {};

	if (!/^import versions$/gi.test(task)) { return; }

	if (/in progress/gi.test(status)) {
		return {
			type: "success",
			messageHeader: "Importing versions in progress",
		};
	}

	if (/failed/gi.test(status)) {
		const { request = {} } = data;
		const { filename = "" } = request;
		const { error } = data?.response;

		return {
			type: "error",
			messageHeader: `Error importing versions sheet`,
			formatter: () => <VersionImportErrorGrowl filename={filename} error={error} />,
		};
	}

	if (/success/gi.test(status)) {
		let { feedback = "" } = data?.response || {};

		return {
			type: "success",
			messageHeader: "Importing versions successful!",
			message: feedback,
		};
	}
}

function IMPORT_VERSIONS_PREVIEW_NOTIFICATIONS(detail) {
	let { task, status, data = {}, jobId } = detail?.message || {};
	const filename = data.request?.filename || "versions";
	const libraryId = data.creativeLibrary?.id;

	if (!/^import versions with preview$/gi.test(task)) { return; }

	if (/failed/gi.test(status)) {
		const error = data.response?.error;

		return {
			type: "error",
			messageHeader: `Error importing versions sheet`,
			formatter: () => <VersionImportErrorGrowl filename={filename} error={error} />,
		};
	}

	if (/success/gi.test(status)) {
		const updatedCreatives = (data?.response?.changes?.creatives || []).filter((creative) => {
			const creativeChanges = creative.updated + creative.new;
			return creativeChanges > 0;
		});

		if(updatedCreatives.length){
			return {
				type: "success",
				messageHeader: "Success!",
				formatter: () => (
					<VersionImportPreviewGrowl
						filename = {filename}
						libraryId = {libraryId}
						jobId = {jobId}
					/>
				),
			};
		} else {
			return {
				type: "success",
				messageHeader: "Success!",
				message: "Import contains no new versions",
			};
		}
	}
}

const GLOBAL_GROWL_MESSAGE_TRIGGERS = [
	EXPORT_VERSIONS_NOTIFICATIONS,
	IMPORT_SOCIAL_NOTIFICATIONS,
	IMPORT_VERSIONS_NOTIFICATIONS,
	IMPORT_VERSIONS_PREVIEW_NOTIFICATIONS,
];

export function GlobalSocketGrowler(){
	useFTMessageGrowl(GLOBAL_GROWL_MESSAGE_TRIGGERS);

	// We don't actually need to render anything.  This is just a vehicle for the hook's effect.
	return null;
}
